import { Link, useParams } from '@tanstack/react-router';
import { Button } from '@tempo-io/sui-button';
import { Effectors } from '@tempo-io/sui-icons';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgName } from '@/common/hooks/useOrgName';
import { EmptyState } from './EmptyState';

interface LoopNoItemsStateProps {
  description?: string;
  additionalAction?: ReactNode;
}

export const LoopNoItemsState = ({ description, additionalAction }: LoopNoItemsStateProps) => {
  const { t } = useTranslation();
  const org = useOrgName();
  const { loopId } = useParams({ strict: false });

  return (
    <EmptyState
      title={t(($) => $.views.visualization.emptyStates.noItems.title)}
      description={description}
      primaryActionNode={
        <div className="flex items-center gap-3">
          {loopId !== undefined ? (
            <Button asChild className="w-60">
              <Link to="/org/$org/loop/$loopId/integrations" params={{ org, loopId }}>
                <Effectors /> {t(($) => $.itemTable.emptyState.button)}
              </Link>
            </Button>
          ) : (
            <Button className="w-60" disabled>
              <Effectors /> {t(($) => $.itemTable.emptyState.button)}
            </Button>
          )}
          {additionalAction && (
            <>
              <span className="text-text-neutral-secondary text-sm">{t(($) => $.common.or)}</span>
              {additionalAction}
            </>
          )}
        </div>
      }
      footer={
        <div className="text-sm text-text-neutral-secondary">
          {t(($) => $.itemTable.emptyState.help)}{' '}
          <a
            href="https://help.tempo.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-text-info"
          >
            {t(($) => $.itemTable.emptyState.guide)}
          </a>{' '}
          {t(($) => $.itemTable.emptyState.helpSuffix)}
        </div>
      }
    />
  );
};
